
export default {
	app: {
		agentChat: {

		},

		agents: {

		},

		companySetting: {

		},

		cannedMessages: {

		},

		chatHistory: {

		},

		currentAgent: {

		},

		customers: {
			userInfo: {
				generalUser: '1',
				vipUser: '2',
				male: '1',
				feMale: '2',
				phoneType: 1,
				emailType: 2,
				userData: 'userData',
				contactRecord: 'contactRecord',
				exitUserInfo: 'exitUserInfo',
				noneUserInfo: 'noneUserInfo'
			},
			channelType: {
				web: 'web',
				ios: 'ios',
				'android': 'android',
				'wx': 'wx'
			}
		},

		dashboard: {
			customerTab: "customerTab",
			colleagueTab: "colleagueTab",

			newSession: "newSession",
			currentSession: "currentSession",
			recentSession: "recentSession",

			colleagueAddressBook: "addressBook",
			colleagueChat: "chat"
		},

		departments: {

		},

		agentProfile: {
			basicInfo: 'basicInfo',
			password: 'password'
		}

	}
}
